import { render, staticRenderFns } from "./EmployeeItem.vue?vue&type=template&id=166e76f9&scoped=true"
import script from "./EmployeeItem.vue?vue&type=script&lang=js"
export * from "./EmployeeItem.vue?vue&type=script&lang=js"
import style0 from "./EmployeeItem.vue?vue&type=style&index=0&id=166e76f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166e76f9",
  null
  
)

export default component.exports